/* Copyright 2016-2022
   Kabandy
   Author: Cedric Hoarau
 */

let _rootDiv: HTMLDivElement | undefined = undefined;
let _modalContentTxtDiv: HTMLDivElement | undefined = undefined;

export namespace UIModal {
    export function Bind(): void {
        _rootDiv = _InitializeUI();
        document.body.appendChild(_rootDiv);
    }

    export function Unbind() {
        if (_modalContentTxtDiv) {
            _modalContentTxtDiv = undefined;
        }
        
        if (_rootDiv) {
            _rootDiv.remove();
        }
    }

    export function Show(innerHtml: string) {
        if( _rootDiv ) {
            if (_modalContentTxtDiv) {
                // @ts-ignore
                _modalContentTxtDiv.innerHTML = DOMPurify.sanitize(innerHtml);
            }

            _rootDiv.style.display = 'block';
        }
    }

    function _InitializeUI(): HTMLDivElement {
        let rootDiv = document.createElement("div");
        rootDiv.id = "ui-modal-root-div";
        rootDiv.style.display = 'none';
        rootDiv.style.position = 'fixed';
        rootDiv.style.zIndex = '1';
        rootDiv.style.left = '0';
        rootDiv.style.top = '0';
        rootDiv.style.width = '100%';
        rootDiv.style.height = '100%';
        rootDiv.style.overflow = 'auto';
        rootDiv.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';

        const modalContent = document.createElement('div');
        modalContent.className = 'ui-modal-content';
        modalContent.style.backgroundColor = '#fefefe';
        modalContent.style.margin = '15% auto';
        modalContent.style.padding = '20px';
        modalContent.style.border = '1px solid #888';
        modalContent.style.width = '80%';
        modalContent.style.maxWidth = '1020px';

        const closeModalBtn = document.createElement('span');
        closeModalBtn.className = 'close';
        // @ts-ignore
        closeModalBtn.innerHTML = DOMPurify.sanitize('&times;');
        closeModalBtn.style.color = '#aaa';
        closeModalBtn.style.float = 'right';
        closeModalBtn.style.fontSize = '28px';
        closeModalBtn.style.fontWeight = 'bold';
        closeModalBtn.style.cursor = 'pointer';
        closeModalBtn.onmouseover = function() {
          closeModalBtn.style.color = 'black';
        };
        closeModalBtn.onmouseleave = function() {
          closeModalBtn.style.color = '#aaa';
        };
        closeModalBtn.onclick = function() {
            rootDiv.style.display = 'none';
          };
        modalContent.appendChild(closeModalBtn);

        _modalContentTxtDiv = document.createElement('div');
        modalContent.appendChild(_modalContentTxtDiv);

        rootDiv.appendChild(modalContent);
        
        return rootDiv;
    }
}
